import {
  getDealerFinanceData,
  getDealersDashboardData,
} from "@Http/dealersDashboard";
import { DealerDashboardFilters } from "@Pages/DealersDashboard/DealersDashboard";
import { useQuery } from "@tanstack/react-query";
import { MutationError } from "@Types/index";

export interface DealerDashboardData {
  data: {
    amountFinancedByMonth: {
      month: number;
      totalAmountFinanced: number;
    }[];
    averageApplicantCreditScore: number;
    averageCoApplicantCreditScore: number;
    averageAge: number;
    totalFundedDeals: number;
    averageDTI: number;
    averageLoanToValue: number;
    medianTerm: number;
    allDealForLTB: number;
    amountFinanced: number;
    averageInterestRate: number;
    allAvailableStates: string[];
    allAvailableCounties: string[];
    lookToBook: number;
    totalAmountRequested: number;
    totalApplications: number;
  };
}
export const useGetDalersDashboard = (query?: DealerDashboardFilters) => {
  const queryKey = ["dealership", query];

  const { data, isLoading, isFetching, error } = useQuery<
    DealerDashboardData,
    MutationError,
    DealerDashboardData
  >({
    queryKey: queryKey,
    queryFn: getDealersDashboardData({
      ...query,
      ...(query?.filterType === "all"
        ? {
            year: undefined,
            month: undefined,
          }
        : query?.filterType === "yearly"
        ? {
            month: undefined,
          }
        : {}),
    }),
  });

  return {
    data: data,
    isLoading,
    isFetching,
    error,
  };
};

export const useGetDealerFinance = (
  id: string,
  query?: DealerDashboardFilters
) => {
  const queryKey = ["dealership-finance", query, id];

  const { data, isLoading, isFetching, error } = useQuery<
    DealerDashboardData,
    MutationError,
    DealerDashboardData
  >({
    queryKey: queryKey,
    queryFn: getDealerFinanceData(id, query),
  });

  return {
    data: data,
    isLoading,
    isFetching,
    error,
  };
};
